// extracted by mini-css-extract-plugin
module.exports = {"transactionNav":"TransactionNavigation_transactionNav__UNe7K","transactionNavButton":"TransactionNavigation_transactionNavButton__1CJmg"};